import { MerchantKnowledgeSuggestionStatus } from "@redotech/cockroachdb-codegen/tables/agent-knowledge/merchant-knowledge-suggestion-status";
import { accountIdFormat } from "@redotech/redo-account-id";
import {
  merchantKnowledgeIdFormat,
  suggestedMerchantKnowledgeIdFormat,
} from "@redotech/shopper-agent-knowledge-id";
import * as z from "zod";
import { retrievalKeySchema } from "./merchant-knowledge-view";

/** What the generator proposes. Same shape a merchant would author. */
export const suggestionDraftSchema = z.object({
  title: z.string(),
  content: z.string(),
});
export type SuggestionDraft = z.infer<typeof suggestionDraftSchema>;

export const suggestionReviewSchema = z.object({
  status: z.enum(MerchantKnowledgeSuggestionStatus),
  reviewedAt: z.date().nullable(),
  /** Hex ObjectId of the reviewing user. */
  reviewedByMongoUserId: z.string().nullable(),
  /** The article this became, once accepted. */
  acceptedMerchantKnowledgeId: merchantKnowledgeIdFormat.schema.nullable(),
});
export type SuggestionReview = z.infer<typeof suggestionReviewSchema>;

export const merchantKnowledgeSuggestionViewSchema = z.object({
  id: suggestedMerchantKnowledgeIdFormat.schema,
  accountId: accountIdFormat.schema,
  title: z.string(),
  content: z.string(),
  /** Derived the same way an article's is, so dedup compares like with like. */
  retrievalKey: retrievalKeySchema,
  review: suggestionReviewSchema,
  createdAt: z.date(),
  updatedAt: z.date(),
});
export type MerchantKnowledgeSuggestionView = z.infer<
  typeof merchantKnowledgeSuggestionViewSchema
>;
